import { FC, ReactNode } from "react";
import { Page } from "@components";
import { stackEnum } from "@utilities/enums";
import { LeftSidebar, MobileBotomTab, Header } from "./components";
import { BymeE } from "../BymeE";
import { useController } from "./useController";

interface Props {
    activeStack: keyof typeof stackEnum;
    children: ReactNode;
    withSubMenu?: boolean;
    onDrawerToggle?: () => void
    onSearch?: (search: string) => void
    handleGoBack?: () => void;
    onCustomMenuButtonPress?: () => void;
}

export const PageWrapper: FC<Props> = ({ 
    activeStack,
    children,
    withSubMenu = false,
    onDrawerToggle,
    onSearch,
    handleGoBack,
    onCustomMenuButtonPress
}) => {

    const {
        user,
        organisation,
        navItems,
        isMenuOpen,
        showLogout,
        onToggleLogout,
        onToggleMenu,
        onNavigateTo,
        onHandleLogout,
    } = useController();

    return (
        <div className="flex h-screen bg-base-200 overflow-hidden">
            <LeftSidebar
                entrepriseName={organisation?.organisationName!}
                collaborator={user!}
                activeStack={activeStack}
                isMenuOpen={isMenuOpen}
                navItems={navItems}
                // onClose={onToggleMenu}
                onLogout={onHandleLogout}
                onNavigateTo={onNavigateTo}
            />

            <div
                className="flex-1 w-full flex flex-col transition-all"
            >
                <Header
                    onDrawerToggle={onDrawerToggle}
                    onSearchChange={onSearch}
                    toggleMenu={onToggleMenu}
                    onGoBack={handleGoBack}
                    onCustomMenuButtonPress={onCustomMenuButtonPress}
                />

                <Page style={withSubMenu ? { padding: 0 } : {}}>
                    <main className={`flex-1 ${!withSubMenu && 'pb-10 lg:p-4'} overflow-auto`}>
                        {children}
                    </main>
                </Page>
            </div>

            <MobileBotomTab 
                activeStack={activeStack} 
                navItems={navItems}
                showLogout={showLogout}
                onToggleLogout={onToggleLogout}
                onNavigateTo={onNavigateTo}
                onLogout={onHandleLogout} 
            />

            <BymeE />
        </div>
    );
};
